// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__ZHldi","title":"ClientInsurance_title__2Bsmb","itemText":"ClientInsurance_itemText__vx_WE"};